import { createContext, useContext, useState, useEffect } from "react";

export const CONTACT_EMAILS = {
  info: "info@auto-vantis.com",
  sales: "sales@auto-vantis.com",
  purchase: "purchase@auto-vantis.com",
};

export const IMAGES = {
  blueCar: "https://static.prod-images.emergentagent.com/jobs/60e848c4-e458-485d-b7d6-9bedfce65408/images/f32d22f7fc427a92be2dd63882ec10439e4dc4ccf6fcce7946f7fee93412e92c.jpeg",
  orangeCar: "https://static.prod-images.emergentagent.com/jobs/60e848c4-e458-485d-b7d6-9bedfce65408/images/dae0fd2ae424e3f391f0d3e6383b32d7912de9331929fe1e7bb198d48063e917.jpeg",
  yard: "/img/yard.jpg",
  handshake: "https://static.prod-images.emergentagent.com/jobs/60e848c4-e458-485d-b7d6-9bedfce65408/images/c78af61a4cf0310f26108ada81682c1a689ef160bfa6635a16cd61aa61dc3f2a.jpeg",
  transporter: "https://static.prod-images.emergentagent.com/jobs/60e848c4-e458-485d-b7d6-9bedfce65408/images/7d315f5c93535617c1c0456f0e04be60c4430d6b163bf50cc3b68ead0d345aad.jpeg",
};

export const BRANDS = {
  european: ["Volkswagen", "Škoda", "SEAT", "CUPRA", "Renault", "Dacia", "Peugeot", "Citroën", "Opel", "Fiat", "Alfa Romeo", "Lancia", "Ford", "MINI"],
  japanese: ["Toyota", "Lexus", "Nissan", "Honda", "Mazda", "Mitsubishi", "Suzuki", "Subaru"],
  korean: ["Hyundai", "Kia", "KGM (formerly SsangYong)"],
  american: ["Jeep", "Chevrolet", "Tesla"],
  chinese: ["BYD", "MG", "Omoda", "Jaecoo", "Chery", "BAIC", "Geely", "Leapmotor", "XPeng", "Changan", "Deepal", "Dongfeng", "DFSK", "Forthing", "GWM (Great Wall Motor)", "Haval", "Ora", "Maxus", "JAC", "Lynk & Co", "Zeekr", "NIO", "Voyah", "Hongqi", "Skywell", "Aiways"],
};

export const BRAND_LOGOS = {
  "Volkswagen": "volkswagen", "Škoda": "skoda", "SEAT": "seat", "CUPRA": "cupra", "Renault": "renault", "Dacia": "dacia",
  "Peugeot": "peugeot", "Citroën": "citroen", "Opel": "opel", "Fiat": "fiat", "Alfa Romeo": "alfa-romeo", "Lancia": "lancia",
  "Ford": "ford", "MINI": "mini", "Toyota": "toyota", "Lexus": "lexus", "Nissan": "nissan", "Honda": "honda", "Mazda": "mazda",
  "Mitsubishi": "mitsubishi", "Suzuki": "suzuki", "Subaru": "subaru", "Hyundai": "hyundai", "Kia": "kia", "Jeep": "jeep",
  "Chevrolet": "chevrolet", "Tesla": "tesla", "BYD": "byd", "MG": "mg", "Omoda": "omoda", "Chery": "chery", "Geely": "geely",
  "Leapmotor": "leapmotor", "XPeng": "xpeng", "Changan": "changan", "Dongfeng": "dongfeng", "GWM (Great Wall Motor)": "great-wall",
  "Haval": "haval", "Maxus": "maxus", "JAC": "jac", "Lynk & Co": "lynk-and-co", "Zeekr": "zeekr", "NIO": "nio", "Hongqi": "hongqi",
  "Aiways": "aiways",
};
export const logoUrl = (name) => (BRAND_LOGOS[name] ? `/logos-white/${BRAND_LOGOS[name]}.png` : null);

const en = {
  nav: { about: "About Us", offer: "Our Offer", brands: "Brands", why: "Why Choose Us", contact: "Contact", cta: "Get in touch" },
  hero: {
    badge: "B2B automotive wholesale · Since 2017",
    title: "Your trusted partner in automotive wholesale",
    titleHl: "automotive wholesale",
    subtitle: "Wholesale passenger cars and light commercial vehicles for car dealers, used car retailers and automotive trading companies across Europe.",
    buyTitle: "Buy vehicles",
    buyPoints: ["350 vehicles sold monthly", "50+ brands from Europe, Asia and America", "Passenger cars and light commercial vehicles"],
    buyCta: "Start buying",
    sellTitle: "Work with us",
    sellPoints: ["Serving business customers across Europe since 2017", "Efficient purchasing processes", "Long-term partnerships built on trust"],
    sellCta: "Contact our team",
  },
  marquee: "Brands we work with across the European market",
  trust: [
    { t: "Since 2017", d: "Automotive wholesale experience" },
    { t: "350 vehicles / month", d: "Proven business scale" },
    { t: "50+ brands", d: "European, Asian and American" },
    { t: "B2B across Europe", d: "For professional buyers" },
  ],
  about: {
    eyebrow: "About Us",
    title: "Your Trusted Partner in Automotive Wholesale",
    p: [
      "Established in 2017, we are a professional automotive wholesale company specializing in the distribution of vehicles to business customers across the European market.",
      "With an average monthly sales volume of 350 vehicles, we combine market knowledge, a reliable supply network and a customer-focused approach to deliver effective solutions for automotive professionals.",
      "Our goal is to make vehicle sourcing straightforward, efficient and profitable. We focus on building long-term business relationships based on trust, transparency and mutual growth.",
      "Whether you are an independent car dealer, a used car retailer or an automotive trading company, we aim to be a reliable partner in your business.",
    ],
    motto: "Experience. Reliability. Long-term partnerships.",
    stats: [{ v: "2017", l: "Established" }, { v: "350", l: "Vehicles per month" }, { v: "50+", l: "Brands" }],
  },
  offer: {
    eyebrow: "Our Offer",
    title: "Wholesale Vehicles. Competitive Opportunities. Reliable Partnerships.",
    p: [
      "We specialize in the wholesale distribution of passenger cars and light commercial vehicles. Our offer is designed for professional automotive buyers looking for a reliable source of vehicles and a diverse selection of brands.",
      "We work with a broad range of manufacturers, from established European and Asian brands to the new generation of Chinese automotive brands entering the European market.",
      "Our portfolio covers a variety of vehicle segments, including city cars, hatchbacks, sedans, SUVs, crossovers and light commercial vehicles.",
      "We focus on providing business customers with access to a constantly evolving vehicle selection, efficient purchasing processes and professional service at every stage of cooperation.",
    ],
    goal: "Our business is built around one goal: helping automotive professionals source the right vehicles for their market.",
    segmentsTitle: "Vehicle segments",
    segments: ["City cars", "Hatchbacks", "Sedans", "SUVs", "Crossovers", "Light commercial vehicles"],
  },
  brands: {
    eyebrow: "Brands We Work With",
    title: "A diverse range of automotive brands",
    p1: "We offer a diverse range of automotive brands to meet the needs of professional buyers across different markets and customer segments.",
    p2: "Our brand portfolio includes established European, Japanese, Korean and American manufacturers, as well as an expanding selection of Chinese automotive brands.",
    note: "Brand availability may vary depending on the market, model and sourcing opportunities. Our portfolio continues to evolve in line with market demand.",
    all: "All brands",
    search: "Search brand…",
    groups: { european: "European brands", japanese: "Japanese brands", korean: "Korean brands", american: "American brands", chinese: "Chinese brands available in European markets" },
    tabs: { european: "European", japanese: "Japanese", korean: "Korean", american: "American", chinese: "Chinese" },
  },
  why: {
    eyebrow: "Why Choose Us?",
    title: "A Reliable Partner for Your Automotive Business",
    p: "We understand the needs of professional car dealers and automotive trading companies. Our approach is built around efficiency, flexibility and long-term cooperation.",
    items: [
      { t: "Experience Since 2017", d: "Years of experience in automotive wholesale." },
      { t: "350 Vehicles Sold Monthly", d: "A proven business scale and an active presence in the market." },
      { t: "Wide Brand Selection", d: "Access to a diverse range of popular automotive brands." },
      { t: "B2B-Focused Service", d: "Solutions tailored to professional buyers and resellers." },
      { t: "Long-Term Partnerships", d: "We value transparent communication and lasting business relationships." },
      { t: "Market-Oriented Approach", d: "We adapt our offer to changing demand and business opportunities." },
    ],
    closing: "Our priority is to help our partners grow by making vehicle sourcing simpler, more efficient and more reliable.",
  },
  contact: {
    eyebrow: "Let's Work Together",
    title: "Looking for a Reliable Vehicle Wholesale Partner?",
    p: [
      "We work with professional car dealers, automotive traders and businesses looking to expand their vehicle sourcing opportunities.",
      "Whether you are interested in regular purchases or looking for specific vehicles, we are ready to discuss your requirements and explore opportunities for cooperation.",
      "Get in touch with our team to learn more about our current offer and business terms.",
    ],
    closing: "Let's build a successful partnership.",
    emailLabels: { info: "General enquiries", sales: "Sales", purchase: "Purchase" },
    formTitle: "Send us an inquiry",
    fields: { name: "Full name", company: "Company", email: "Business email", phone: "Phone (optional)", country: "Country", interest: "I'm interested in", message: "Your message" },
    interests: { regular: "Regular purchases", specific: "Specific vehicles", selling: "Selling vehicles to Autovantis", other: "Other" },
    submit: "Send inquiry",
    sending: "Sending...",
    success: "Thank you! Your inquiry has been sent. Our team will get back to you shortly.",
    error: "Something went wrong. Please try again or email us directly.",
    required: "Please fill in all required fields.",
    invalidEmail: "Please enter a valid email address.",
  },
  footer: {
    desc: "Professional automotive wholesale for business customers across the European market since 2017.",
    company: "Company", contact: "Contact us", languages: "Language",
    rights: "All rights reserved.", privacy: "Data privacy", terms: "T&C", imprint: "Imprint",
  },
};

const de = {
  nav: { about: "Über uns", offer: "Unser Angebot", brands: "Marken", why: "Warum wir", contact: "Kontakt", cta: "Kontakt aufnehmen" },
  hero: {
    badge: "B2B-Automobil-Großhandel · Seit 2017",
    title: "Ihr zuverlässiger Partner im Automobil-Großhandel",
    titleHl: "Automobil-Großhandel",
    subtitle: "Pkw und leichte Nutzfahrzeuge im Großhandel für Autohändler, Gebrauchtwagenhändler und Automobilhandelsunternehmen in ganz Europa.",
    buyTitle: "Fahrzeuge kaufen",
    buyPoints: ["350 verkaufte Fahrzeuge pro Monat", "50+ Marken aus Europa, Asien und Amerika", "Pkw und leichte Nutzfahrzeuge"],
    buyCta: "Jetzt kaufen",
    sellTitle: "Mit uns arbeiten",
    sellPoints: ["Seit 2017 für Geschäftskunden in ganz Europa", "Effiziente Einkaufsprozesse", "Langfristige Partnerschaften auf Vertrauensbasis"],
    sellCta: "Team kontaktieren",
  },
  marquee: "Marken, mit denen wir auf dem europäischen Markt arbeiten",
  trust: [
    { t: "Seit 2017", d: "Erfahrung im Automobil-Großhandel" },
    { t: "350 Fahrzeuge / Monat", d: "Bewährte Geschäftsgröße" },
    { t: "50+ Marken", d: "Europäisch, asiatisch und amerikanisch" },
    { t: "B2B in ganz Europa", d: "Für professionelle Einkäufer" },
  ],
  about: {
    eyebrow: "Über uns",
    title: "Ihr zuverlässiger Partner im Automobil-Großhandel",
    p: [
      "Wir wurden 2017 gegründet und sind ein professionelles Automobil-Großhandelsunternehmen, das sich auf den Vertrieb von Fahrzeugen an Geschäftskunden auf dem europäischen Markt spezialisiert hat.",
      "Mit einem durchschnittlichen monatlichen Absatz von 350 Fahrzeugen verbinden wir Marktkenntnis, ein zuverlässiges Liefernetzwerk und einen kundenorientierten Ansatz, um wirksame Lösungen für Automobilprofis zu bieten.",
      "Unser Ziel ist es, die Fahrzeugbeschaffung einfach, effizient und profitabel zu gestalten. Wir setzen auf langfristige Geschäftsbeziehungen, die auf Vertrauen, Transparenz und gemeinsamem Wachstum beruhen.",
      "Ob unabhängiger Autohändler, Gebrauchtwagenhändler oder Automobilhandelsunternehmen – wir möchten ein verlässlicher Partner für Ihr Geschäft sein.",
    ],
    motto: "Erfahrung. Zuverlässigkeit. Langfristige Partnerschaften.",
    stats: [{ v: "2017", l: "Gegründet" }, { v: "350", l: "Fahrzeuge pro Monat" }, { v: "50+", l: "Marken" }],
  },
  offer: {
    eyebrow: "Unser Angebot",
    title: "Großhandelsfahrzeuge. Attraktive Chancen. Verlässliche Partnerschaften.",
    p: [
      "Wir sind auf den Großhandelsvertrieb von Pkw und leichten Nutzfahrzeugen spezialisiert. Unser Angebot richtet sich an professionelle Automobileinkäufer, die eine zuverlässige Fahrzeugquelle und eine vielfältige Markenauswahl suchen.",
      "Wir arbeiten mit einem breiten Spektrum an Herstellern – von etablierten europäischen und asiatischen Marken bis hin zur neuen Generation chinesischer Automobilmarken, die auf den europäischen Markt kommen.",
      "Unser Portfolio umfasst verschiedene Fahrzeugsegmente, darunter Kleinwagen, Kompaktwagen, Limousinen, SUVs, Crossover und leichte Nutzfahrzeuge.",
      "Wir bieten Geschäftskunden Zugang zu einer sich ständig weiterentwickelnden Fahrzeugauswahl, effiziente Einkaufsprozesse und professionellen Service in jeder Phase der Zusammenarbeit.",
    ],
    goal: "Unser Geschäft basiert auf einem Ziel: Automobilprofis dabei zu helfen, die richtigen Fahrzeuge für ihren Markt zu beschaffen.",
    segmentsTitle: "Fahrzeugsegmente",
    segments: ["Kleinwagen", "Kompaktwagen", "Limousinen", "SUVs", "Crossover", "Leichte Nutzfahrzeuge"],
  },
  brands: {
    eyebrow: "Unsere Marken",
    title: "Eine vielfältige Auswahl an Automobilmarken",
    p1: "Wir bieten eine vielfältige Auswahl an Automobilmarken, um die Anforderungen professioneller Einkäufer in unterschiedlichen Märkten und Kundensegmenten zu erfüllen.",
    p2: "Unser Markenportfolio umfasst etablierte europäische, japanische, koreanische und amerikanische Hersteller sowie eine wachsende Auswahl chinesischer Automobilmarken.",
    note: "Die Verfügbarkeit der Marken kann je nach Markt, Modell und Beschaffungsmöglichkeiten variieren. Unser Portfolio entwickelt sich entsprechend der Marktnachfrage stetig weiter.",
    all: "Alle Marken",
    search: "Marke suchen…",
    groups: { european: "Europäische Marken", japanese: "Japanische Marken", korean: "Koreanische Marken", american: "Amerikanische Marken", chinese: "Chinesische Marken auf europäischen Märkten" },
    tabs: { european: "Europäisch", japanese: "Japanisch", korean: "Koreanisch", american: "Amerikanisch", chinese: "Chinesisch" },
  },
  why: {
    eyebrow: "Warum wir?",
    title: "Ein zuverlässiger Partner für Ihr Automobilgeschäft",
    p: "Wir verstehen die Bedürfnisse professioneller Autohändler und Automobilhandelsunternehmen. Unser Ansatz basiert auf Effizienz, Flexibilität und langfristiger Zusammenarbeit.",
    items: [
      { t: "Erfahrung seit 2017", d: "Jahrelange Erfahrung im Automobil-Großhandel." },
      { t: "350 verkaufte Fahrzeuge pro Monat", d: "Eine bewährte Geschäftsgröße und aktive Marktpräsenz." },
      { t: "Große Markenauswahl", d: "Zugang zu einer vielfältigen Auswahl beliebter Automobilmarken." },
      { t: "B2B-orientierter Service", d: "Lösungen, zugeschnitten auf professionelle Einkäufer und Wiederverkäufer." },
      { t: "Langfristige Partnerschaften", d: "Wir schätzen transparente Kommunikation und dauerhafte Geschäftsbeziehungen." },
      { t: "Marktorientierter Ansatz", d: "Wir passen unser Angebot an veränderte Nachfrage und Geschäftschancen an." },
    ],
    closing: "Unsere Priorität ist es, das Wachstum unserer Partner zu fördern, indem wir die Fahrzeugbeschaffung einfacher, effizienter und zuverlässiger machen.",
  },
  contact: {
    eyebrow: "Lassen Sie uns zusammenarbeiten",
    title: "Suchen Sie einen zuverlässigen Partner für den Fahrzeug-Großhandel?",
    p: [
      "Wir arbeiten mit professionellen Autohändlern, Automobilhändlern und Unternehmen, die ihre Möglichkeiten der Fahrzeugbeschaffung erweitern möchten.",
      "Ob Sie an regelmäßigen Einkäufen interessiert sind oder bestimmte Fahrzeuge suchen – wir sind bereit, Ihre Anforderungen zu besprechen und Möglichkeiten der Zusammenarbeit auszuloten.",
      "Kontaktieren Sie unser Team, um mehr über unser aktuelles Angebot und unsere Geschäftsbedingungen zu erfahren.",
    ],
    closing: "Lassen Sie uns eine erfolgreiche Partnerschaft aufbauen.",
    emailLabels: { info: "Allgemeine Anfragen", sales: "Verkauf", purchase: "Einkauf" },
    formTitle: "Anfrage senden",
    fields: { name: "Vollständiger Name", company: "Unternehmen", email: "Geschäftliche E-Mail", phone: "Telefon (optional)", country: "Land", interest: "Ich interessiere mich für", message: "Ihre Nachricht" },
    interests: { regular: "Regelmäßige Einkäufe", specific: "Bestimmte Fahrzeuge", selling: "Fahrzeuge an Autovantis verkaufen", other: "Sonstiges" },
    submit: "Anfrage senden",
    sending: "Wird gesendet...",
    success: "Vielen Dank! Ihre Anfrage wurde gesendet. Unser Team meldet sich in Kürze bei Ihnen.",
    error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt.",
    required: "Bitte füllen Sie alle Pflichtfelder aus.",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  },
  footer: {
    desc: "Professioneller Automobil-Großhandel für Geschäftskunden auf dem europäischen Markt seit 2017.",
    company: "Unternehmen", contact: "Kontakt", languages: "Sprache",
    rights: "Alle Rechte vorbehalten.", privacy: "Datenschutz", terms: "AGB", imprint: "Impressum",
  },
};

const fr = {
  nav: { about: "À propos", offer: "Notre offre", brands: "Marques", why: "Pourquoi nous", contact: "Contact", cta: "Nous contacter" },
  hero: {
    badge: "Vente automobile B2B en gros · Depuis 2017",
    title: "Votre partenaire de confiance dans la vente automobile en gros",
    titleHl: "vente automobile en gros",
    subtitle: "Voitures particulières et véhicules utilitaires légers en gros pour les concessionnaires, revendeurs de véhicules d'occasion et sociétés de négoce automobile en Europe.",
    buyTitle: "Acheter des véhicules",
    buyPoints: ["350 véhicules vendus chaque mois", "Plus de 50 marques d'Europe, d'Asie et d'Amérique", "Voitures particulières et véhicules utilitaires légers"],
    buyCta: "Commencer à acheter",
    sellTitle: "Travailler avec nous",
    sellPoints: ["Au service des professionnels en Europe depuis 2017", "Des processus d'achat efficaces", "Des partenariats durables fondés sur la confiance"],
    sellCta: "Contacter notre équipe",
  },
  marquee: "Les marques avec lesquelles nous travaillons sur le marché européen",
  trust: [
    { t: "Depuis 2017", d: "Expérience dans la vente automobile en gros" },
    { t: "350 véhicules / mois", d: "Une envergure éprouvée" },
    { t: "Plus de 50 marques", d: "Européennes, asiatiques et américaines" },
    { t: "B2B dans toute l'Europe", d: "Pour les acheteurs professionnels" },
  ],
  about: {
    eyebrow: "À propos",
    title: "Votre partenaire de confiance dans la vente automobile en gros",
    p: [
      "Fondée en 2017, nous sommes une entreprise professionnelle de vente automobile en gros, spécialisée dans la distribution de véhicules aux clients professionnels sur le marché européen.",
      "Avec un volume moyen de 350 véhicules vendus par mois, nous associons connaissance du marché, réseau d'approvisionnement fiable et approche centrée sur le client pour offrir des solutions efficaces aux professionnels de l'automobile.",
      "Notre objectif est de rendre l'approvisionnement en véhicules simple, efficace et rentable. Nous privilégions des relations commerciales durables fondées sur la confiance, la transparence et la croissance mutuelle.",
      "Que vous soyez concessionnaire indépendant, revendeur de véhicules d'occasion ou société de négoce automobile, nous souhaitons être un partenaire fiable pour votre activité.",
    ],
    motto: "Expérience. Fiabilité. Partenariats durables.",
    stats: [{ v: "2017", l: "Fondée en" }, { v: "350", l: "Véhicules par mois" }, { v: "50+", l: "Marques" }],
  },
  offer: {
    eyebrow: "Notre offre",
    title: "Véhicules en gros. Opportunités compétitives. Partenariats fiables.",
    p: [
      "Nous sommes spécialisés dans la distribution en gros de voitures particulières et de véhicules utilitaires légers. Notre offre s'adresse aux acheteurs automobiles professionnels à la recherche d'une source fiable de véhicules et d'un large choix de marques.",
      "Nous travaillons avec un large éventail de constructeurs, des marques européennes et asiatiques reconnues à la nouvelle génération de marques automobiles chinoises qui arrivent sur le marché européen.",
      "Notre portefeuille couvre différents segments de véhicules : citadines, compactes, berlines, SUV, crossovers et véhicules utilitaires légers.",
      "Nous offrons à nos clients professionnels l'accès à une sélection de véhicules en constante évolution, des processus d'achat efficaces et un service professionnel à chaque étape de la coopération.",
    ],
    goal: "Notre activité repose sur un seul objectif : aider les professionnels de l'automobile à trouver les bons véhicules pour leur marché.",
    segmentsTitle: "Segments de véhicules",
    segments: ["Citadines", "Compactes", "Berlines", "SUV", "Crossovers", "Utilitaires légers"],
  },
  brands: {
    eyebrow: "Nos marques",
    title: "Un large éventail de marques automobiles",
    p1: "Nous proposons un large éventail de marques automobiles pour répondre aux besoins des acheteurs professionnels sur différents marchés et segments de clientèle.",
    p2: "Notre portefeuille comprend des constructeurs européens, japonais, coréens et américains reconnus, ainsi qu'une sélection croissante de marques automobiles chinoises.",
    note: "La disponibilité des marques peut varier selon le marché, le modèle et les opportunités d'approvisionnement. Notre portefeuille évolue en fonction de la demande du marché.",
    all: "Toutes les marques",
    search: "Rechercher une marque…",
    groups: { european: "Marques européennes", japanese: "Marques japonaises", korean: "Marques coréennes", american: "Marques américaines", chinese: "Marques chinoises disponibles sur les marchés européens" },
    tabs: { european: "Européennes", japanese: "Japonaises", korean: "Coréennes", american: "Américaines", chinese: "Chinoises" },
  },
  why: {
    eyebrow: "Pourquoi nous choisir ?",
    title: "Un partenaire fiable pour votre activité automobile",
    p: "Nous comprenons les besoins des concessionnaires professionnels et des sociétés de négoce automobile. Notre approche repose sur l'efficacité, la flexibilité et la coopération à long terme.",
    items: [
      { t: "Expérience depuis 2017", d: "Des années d'expérience dans la vente automobile en gros." },
      { t: "350 véhicules vendus par mois", d: "Une envergure commerciale éprouvée et une présence active sur le marché." },
      { t: "Large choix de marques", d: "Accès à une gamme variée de marques automobiles populaires." },
      { t: "Service axé B2B", d: "Des solutions adaptées aux acheteurs et revendeurs professionnels." },
      { t: "Partenariats durables", d: "Nous privilégions une communication transparente et des relations commerciales durables." },
      { t: "Approche orientée marché", d: "Nous adaptons notre offre à l'évolution de la demande et des opportunités." },
    ],
    closing: "Notre priorité est d'aider nos partenaires à se développer en rendant l'approvisionnement en véhicules plus simple, plus efficace et plus fiable.",
  },
  contact: {
    eyebrow: "Travaillons ensemble",
    title: "Vous recherchez un partenaire fiable pour l'achat de véhicules en gros ?",
    p: [
      "Nous travaillons avec des concessionnaires professionnels, des négociants automobiles et des entreprises souhaitant élargir leurs possibilités d'approvisionnement en véhicules.",
      "Que vous soyez intéressé par des achats réguliers ou à la recherche de véhicules spécifiques, nous sommes prêts à discuter de vos besoins et à explorer les possibilités de coopération.",
      "Contactez notre équipe pour en savoir plus sur notre offre actuelle et nos conditions commerciales.",
    ],
    closing: "Construisons ensemble un partenariat réussi.",
    emailLabels: { info: "Demandes générales", sales: "Ventes", purchase: "Achats" },
    formTitle: "Envoyez-nous une demande",
    fields: { name: "Nom complet", company: "Société", email: "E-mail professionnel", phone: "Téléphone (facultatif)", country: "Pays", interest: "Je suis intéressé par", message: "Votre message" },
    interests: { regular: "Achats réguliers", specific: "Véhicules spécifiques", selling: "Vendre des véhicules à Autovantis", other: "Autre" },
    submit: "Envoyer la demande",
    sending: "Envoi...",
    success: "Merci ! Votre demande a bien été envoyée. Notre équipe vous répondra rapidement.",
    error: "Une erreur s'est produite. Veuillez réessayer ou nous écrire directement.",
    required: "Veuillez remplir tous les champs obligatoires.",
    invalidEmail: "Veuillez saisir une adresse e-mail valide.",
  },
  footer: {
    desc: "Vente automobile en gros pour les clients professionnels sur le marché européen depuis 2017.",
    company: "Entreprise", contact: "Nous contacter", languages: "Langue",
    rights: "Tous droits réservés.", privacy: "Confidentialité", terms: "CGV", imprint: "Mentions légales",
  },
};

const vehiclesEn = {
  eyebrow: "Vehicles", title: "Current wholesale vehicles", subtitle: "A selection of vehicles currently available to our business partners. Send us a request for pricing and availability.",
  requestPrice: "Request for price", priceNote: "Prices on request for business partners", b2bOnly: "B2B only", b2bNote: "For business customers only. All vehicles are offered by Autovantis.",
  viewAll: "View all vehicles", hp: "hp", details: "Details", units: "units", sample: "Sample",
  searchPlaceholder: "Search make or model…", allMakes: "All makes", allBodies: "All body types", allFuels: "All fuel types", results: "vehicles",
  empty: "No vehicles match your filters.", back: "Back to all vehicles", notFound: "This vehicle is no longer available.",
  request: "Request price & availability", requestTitle: "Request price & availability", requestMessage: "Hello, we are interested in this vehicle. Please send us your price offer and availability.",
  sort: { newest: "Newest first", year_desc: "Newest model year", km_asc: "Lowest mileage" },
  status: { available: "Available", reserved: "Reserved", sold: "Sold" },
  fuel: { petrol: "Petrol", diesel: "Diesel", hybrid: "Hybrid", plug_in_hybrid: "Plug-in hybrid", electric: "Electric", lpg: "LPG" },
  transmission: { manual: "Manual", automatic: "Automatic" },
  body: { city_car: "City car", hatchback: "Hatchback", sedan: "Sedan", suv: "SUV", crossover: "Crossover", estate: "Estate", lcv: "Light commercial", other: "Other" },
  spec: { year: "Year", mileage: "Mileage", fuel: "Fuel", transmission: "Transmission", body: "Body type", power: "Power", color: "Colour", location: "Location", quantity: "Units available" },
};
const vehiclesDe = {
  eyebrow: "Fahrzeuge", title: "Aktuelle Großhandelsfahrzeuge", subtitle: "Eine Auswahl an Fahrzeugen, die derzeit für unsere Geschäftspartner verfügbar sind. Senden Sie uns eine Anfrage zu Preis und Verfügbarkeit.",
  requestPrice: "Preis auf Anfrage", priceNote: "Preise auf Anfrage für Geschäftspartner", b2bOnly: "Nur B2B", b2bNote: "Nur für Geschäftskunden. Alle Fahrzeuge werden von Autovantis angeboten.",
  viewAll: "Alle Fahrzeuge ansehen", hp: "PS", details: "Details", units: "Stück", sample: "Beispiel",
  searchPlaceholder: "Marke oder Modell suchen…", allMakes: "Alle Marken", allBodies: "Alle Karosserien", allFuels: "Alle Kraftstoffe", results: "Fahrzeuge",
  empty: "Keine Fahrzeuge entsprechen Ihren Filtern.", back: "Zurück zu allen Fahrzeugen", notFound: "Dieses Fahrzeug ist nicht mehr verfügbar.",
  request: "Preis & Verfügbarkeit anfragen", requestTitle: "Preis & Verfügbarkeit anfragen", requestMessage: "Guten Tag, wir interessieren uns für dieses Fahrzeug. Bitte senden Sie uns Ihr Preisangebot und die Verfügbarkeit.",
  sort: { newest: "Neueste zuerst", year_desc: "Neuestes Baujahr", km_asc: "Niedrigster Kilometerstand" },
  status: { available: "Verfügbar", reserved: "Reserviert", sold: "Verkauft" },
  fuel: { petrol: "Benzin", diesel: "Diesel", hybrid: "Hybrid", plug_in_hybrid: "Plug-in-Hybrid", electric: "Elektro", lpg: "Autogas (LPG)" },
  transmission: { manual: "Schaltgetriebe", automatic: "Automatik" },
  body: { city_car: "Kleinwagen", hatchback: "Kompaktwagen", sedan: "Limousine", suv: "SUV", crossover: "Crossover", estate: "Kombi", lcv: "Leichtes Nutzfahrzeug", other: "Sonstige" },
  spec: { year: "Baujahr", mileage: "Kilometerstand", fuel: "Kraftstoff", transmission: "Getriebe", body: "Karosserie", power: "Leistung", color: "Farbe", location: "Standort", quantity: "Verfügbare Stück" },
};
const vehiclesFr = {
  eyebrow: "Véhicules", title: "Véhicules disponibles en gros", subtitle: "Une sélection de véhicules actuellement disponibles pour nos partenaires professionnels. Envoyez-nous une demande de prix et de disponibilité.",
  requestPrice: "Prix sur demande", priceNote: "Prix sur demande pour les partenaires professionnels", b2bOnly: "B2B uniquement", b2bNote: "Réservé aux clients professionnels. Tous les véhicules sont proposés par Autovantis.",
  viewAll: "Voir tous les véhicules", hp: "ch", details: "Détails", units: "unités", sample: "Exemple",
  searchPlaceholder: "Rechercher une marque ou un modèle…", allMakes: "Toutes les marques", allBodies: "Toutes les carrosseries", allFuels: "Tous les carburants", results: "véhicules",
  empty: "Aucun véhicule ne correspond à vos filtres.", back: "Retour à tous les véhicules", notFound: "Ce véhicule n'est plus disponible.",
  request: "Demander prix et disponibilité", requestTitle: "Demander prix et disponibilité", requestMessage: "Bonjour, ce véhicule nous intéresse. Merci de nous envoyer votre offre de prix et sa disponibilité.",
  sort: { newest: "Plus récents", year_desc: "Année la plus récente", km_asc: "Kilométrage le plus bas" },
  status: { available: "Disponible", reserved: "Réservé", sold: "Vendu" },
  fuel: { petrol: "Essence", diesel: "Diesel", hybrid: "Hybride", plug_in_hybrid: "Hybride rechargeable", electric: "Électrique", lpg: "GPL" },
  transmission: { manual: "Manuelle", automatic: "Automatique" },
  body: { city_car: "Citadine", hatchback: "Compacte", sedan: "Berline", suv: "SUV", crossover: "Crossover", estate: "Break", lcv: "Utilitaire léger", other: "Autre" },
  spec: { year: "Année", mileage: "Kilométrage", fuel: "Carburant", transmission: "Boîte", body: "Carrosserie", power: "Puissance", color: "Couleur", location: "Emplacement", quantity: "Unités disponibles" },
};
Object.assign(en, { vehicles: vehiclesEn });
Object.assign(de, { vehicles: vehiclesDe });
Object.assign(fr, { vehicles: vehiclesFr });
en.nav.vehicles = "Vehicles";
de.nav.vehicles = "Fahrzeuge";
fr.nav.vehicles = "Véhicules";

export const translations = { en, de, fr };
export const LANGS = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
];

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("av-lang") || "en");
  useEffect(() => {
    localStorage.setItem("av-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
